export const style = {
  menu: {
    searchItem: {
      style: {
        backgroundColor: 'transparent',
        padding: '8px',
      },
      textPosition: 'start',
      textFontSize: 'small',
    },
    button: {
      color: 'inherit',
      fontSize: 'small',
    },
    paperProps: { style: { minWidth: 350 } },
    item: {
      label: {
        sx: {
          flexGrow: 1,
          mr: 0,
        },
      },
    },
  },
  resultCounter: {
    sx: {
      pl: 2,
      color: 'text.secondary',
    },
    variant: 'overline',
  },
  loader: {
    box: {
      sx: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: 4,
      },
    },
  },
} as const;
